export default[
    {
        show(row,extra){
            return row.shbj == '1' && row.extstr1 == '1' && row.xtts == '1';
        },
        tag:"el-tag",
        type:"success",
        text(row,extra){
            return row.extstr2 + "(已推送)"
        }
    },
    {
        show(row,extra){
            return row.shbj == '1' && row.extstr1 == '1' && row.xtts != '1';
        },
        tag:"el-tag",
        type:"warning",
        text(row,extra){
            return row.extstr2 + "(待推送)"
        }
    },
    {
        show(row,extra){
            return row.shbj == '1' && row.extstr1 != '1';
        },
        tag:"el-tag",
        type:"info",
        text(row,extra){
            return row.extstr2 + "(无需推送)"
        }
    },
    {
        show(row,extra){
            return row.shbj != '1';
        },
        tag:"el-tag",
        type:"info",
        text(row,extra){
            return row.extstr2
        }
    },
]